import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { InvoiceState } from "./invoicing.types";
import { invoiceApi } from "./invoicing.api";
import { RootState } from "../../app/store";
import { withErrorHandler } from "../../app/core-slice";

const initialState: InvoiceState = {
    invoiceFilter: {
        searchTerm: "",
        overDue: false,
        isTemplate: false,
    },
    invoiceSearchResults: {
        items: [],
        total: 0,
    },
    invoiceSearchInprogress: false,
};

export const fetchInvoicesAsync = createAsyncThunk(
    "invoice/fetchInvoiceList",
    withErrorHandler(invoiceApi.searchInvoices)
);

export const fetchInvoiceAsync = createAsyncThunk("invoice/fetchInvoice", withErrorHandler(invoiceApi.getInvoice));

const invoiceSlice = createSlice({
    name: "invoice",
    initialState,
    reducers: {
        setInvoiceFilter(state, action: PayloadAction<any>) {
            state.invoiceFilter = { ...state.invoiceFilter, ...action.payload };
        },
        setCreateNewInvoice(state, action: PayloadAction<boolean>) {
            state.createNewInvoice = action.payload;
        },
        clearEditingInvoice(state) {
            state.editingInvoice = undefined;
            state.createNewInvoice = false;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchInvoicesAsync.pending, (state) => {
                state.invoiceSearchInprogress = true;
            })
            .addCase(fetchInvoicesAsync.fulfilled, (state, action) => {
                state.invoiceSearchResults = action.payload;
                state.invoiceSearchInprogress = false;
            })
            .addCase(fetchInvoicesAsync.rejected, (state) => {
                state.invoiceSearchInprogress = false;
            })
            .addCase(fetchInvoiceAsync.pending, (state) => {
                state.editingInvoice = undefined;
            })
            .addCase(fetchInvoiceAsync.fulfilled, (state, action) => {
                state.editingInvoice = action.payload;
            })
            .addCase(fetchInvoiceAsync.rejected, (state) => {
                state.editingInvoice = undefined;
            });
    },
});

export const { setInvoiceFilter, setCreateNewInvoice, clearEditingInvoice } = invoiceSlice.actions;

export default invoiceSlice.reducer;

//Selectors
export const selectInvoiceFilter = (state: RootState) => state.invoicing.invoiceFilter;
export const selectInvoiceSearchResults = (state: RootState) => state.invoicing.invoiceSearchResults;
export const selectInvoiceSearchInprogress = (state: RootState) => state.invoicing.invoiceSearchInprogress;
export const selectEditingInvoice = (state: RootState) => state.invoicing.editingInvoice;
export const selectCreateNewInvoice = (state: RootState) => state.invoicing.createNewInvoice;
